import { accountBadgeEntityName } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Image } from '@juvare/platform-sdk-react/ui/components';
import FlipOutlinedIcon from '@mui/icons-material/FlipOutlined';
import { Box, Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { BadgePreviewContextProvider } from '../contexts/BadgePreviewContext';
export const BadgePreviewAttachmentModal = ({ ariaTitleId, ariaContentId, entityId, title, badgePreviewContext, close, }) => {
    const { t } = useBadgingTranslation();
    const [isBackTemplateVisible, setIsBackTemplateVisible] = React.useState(false);
    const handleFlipTemplate = () => {
        setIsBackTemplateVisible((prevState) => !prevState);
    };
    return (React.createElement(BadgePreviewContextProvider, Object.assign({}, badgePreviewContext),
        React.createElement(DialogTitle, { id: ariaTitleId }, t('badgePreview.previewModalTitle', {
            templateTitle: title,
        })),
        React.createElement(DialogContent, { sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }, id: ariaContentId },
            React.createElement(Box, { sx: {
                    px: 5,
                    py: 2,
                    borderRadius: 1,
                    backgroundColor: themeColors.surface.secondary,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                } },
                React.createElement(Image, { entity: accountBadgeEntityName, entityId: entityId, attachmentKey: isBackTemplateVisible ? 'accountBadgeBackImage' : 'accountBadgeFrontImage', sx: { width: '100%' } }),
                React.createElement(Button, { startIcon: React.createElement(FlipOutlinedIcon, null), onClick: handleFlipTemplate }, t('badgePreview.flipBadge')))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { variant: 'text', color: 'primary', onClick: () => close() }, t('badges.badgeCard.close')))));
};
